import Checkbox from '@ben/orion/checkbox';
import Input from '@ben/orion/input';
import Switch from '@ben/orion/switch';
import { Controller, useFormContext } from 'react-hook-form';
import styled, { css } from 'styled-components';
import { fieldCannotBeBlankErrorMessage } from '../../../shared/constants';

interface IModularCheckboxInputProps {
  componentControllerName: string;
}

const ModularCheckboxInput = ({
  componentControllerName,
}: IModularCheckboxInputProps) => {
  const { control } = useFormContext();

  return (
    <>
      <ComponentsWrapper>
        <Controller
          control={control}
          name={`${componentControllerName}.showLabel`}
          render={({ field: { value, onChange } }) => (
            <Switch
              label="Show label"
              defaultValue={Boolean(value ?? true)}
              onChange={(next: boolean) => onChange(Boolean(next))}
            />
          )}
        />
        <Controller
          control={control}
          name={`${componentControllerName}.label`}
          render={({ field, fieldState }) => (
            <Input
              {...field}
              name="Input label"
              hasError={!!fieldState.error}
              errorMessage={fieldState.error?.message}
            />
          )}
          rules={{ required: fieldCannotBeBlankErrorMessage }}
        />
      </ComponentsWrapper>
      <ComponentsWrapper>
        <Controller
          control={control}
          name={`${componentControllerName}.default`}
          render={({ field: { value, onChange } }) => (
            <Checkbox
              label="Default"
              value={Boolean(value)}
              onChange={(next: boolean | { target?: { checked?: boolean } }) =>
                onChange(
                  typeof next === 'boolean'
                    ? next
                    : Boolean(next?.target?.checked)
                )
              }
            />
          )}
        />
        <Controller
          control={control}
          name={`${componentControllerName}.requireTrue`}
          render={({ field: { value, onChange } }) => (
            <Checkbox
              label="Must be selected"
              value={Boolean(value)}
              onChange={(next: boolean | { target?: { checked?: boolean } }) =>
                onChange(
                  typeof next === 'boolean'
                    ? next
                    : Boolean(next?.target?.checked)
                )
              }
            />
          )}
        />
      </ComponentsWrapper>
    </>
  );
};

export default ModularCheckboxInput;

const ComponentsWrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing(2)};
  `}
`;
